import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

export const paidSocialToolkitMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.PAID_SOCIAL,
  iFrameSrcUrl: '/social',
  micrositeUrl: 'social',
  title: {
    id: 'paidSocial.title',
    defaultMessage: 'Get help navigating all of life’s ups and downs',
    description: 'Microsite page title',
  },
  featureFlag: 'isPaidSocialToolkitEnabled',
  customerPropertyConditions: [
    {
      key: 'libraryDisabled',
      value: true,
    },
  ],
  postMessageEvents: [
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_REGISTRATION,
    },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_ESSENTIALS,
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.CLICK_SELF_CARE_CONTENT },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.REGISTER_WEBINAR,
      params: {
        webinarLink: '/secure/index/essentials/events',
      },
    },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_FORKED_TRIAGE,
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_WEBINAR_EVENTS },
  ],
  page: '2025 social',
  trackUTMParams: {
    utm_campaign: '2025social',
  },
  customMixpanelEventProps: {
    toolkit_topic: 'lyra paid social campaign',
  },
  shouldSupportSpanish: false,
  shouldHideForInternational: true,
}
